export default "__VITE_ASSET__PoUpYobQ__"